<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content">

                
                <div class="row mb-32 gy-0 dash-top" style="padding-bottom: 500px; ">

                    <!-- BANNER -->
                    <div class="col-12 " style="margin-top: -10px;">

                        <div class="hp-bg-black-b py-32 py-sm-64 px-24 px-sm-48 px-md-80 position-relative overflow-hidden hp-page-content"
                            style="border-radius: 20px; background-color: black;">

                            <div class="row ">
                                <div class="col-sm-6 col-12" style="z-index: 50;">
                                    <div class="row ">

                                        <div class="col-12 mm-none" >
                                            <p class="hp-p1-body text-black-0 mt-18" style="font-weight: 100; font-size: 12px;">Total models</p>

                                            <h1 class="mb-8"
                                                style="font-size: 42px; line-height: 100%; margin-top: -5px; color: #fff;">
                                                {{ modelCount }}
                                            </h1>

                                        </div>

                                        <div class="col-12 dd-none" >

                                            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">

                                                <p class="hp-p1-body text-black-0 mt-18" style="font-weight: 100; font-size: 12px;">Total models</p>
                                                <h1 class="mb-8"
                                                    style="font-size: 42px; line-height: 100%; margin-top: -5px; color: #fff;">
                                                    {{ modelCount }}
                                                </h1>

                                            </div>

                                            

                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>

                    <!-- POSTS -->
                    <div class="col-12" style="z-index: 9;">

                        <div class="row g-32">

                            <div class="col-12 col-xl-12">

                                <div class="mt-18 mb-24">

                                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" style="background-color: transparent;" placeholder="Search Users...">

                                </div>

                                <!-- DUPLI -->
                                        <div class="row" >
                                            <div class="col-12 col-xl-4" style="margin-bottom: 20px;" v-for="user in modelsList" :key="user.id">
                                            <div class="card hp-card-6">

                                                <img :src="user.profileBack" alt="" style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px;" >
                                                <!-- <div style="width: 100%; height: 100px; object-fit: cover; border-top-left-radius: 20px; border-top-right-radius: 20px; background-color: rgba(0,0,0,0.3); margin-top: -100px;"></div> -->
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-12 text-center">

                                                            <div  style="padding-left: 10px; padding-right:10px; margin-top: -50px;">

                                                                <div class="mb-32">

                                                                    <img :src="user.profilePic" alt="" style="object-fit: cover; width: 70px; height: 70px; border-radius: 50%; border-width: 1px; border-style: solid; border-color: black;">

                                                                    <h6 style="text-align: center; margin-top: 10px;">{{ user.fullName }}</h6>
                                                                    <p style="text-align: center; margin-top: -15px;">@{{ user.userName }}</p>
                                                                </div>

                                                                <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0"></div>
                                                                

                                                                <div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Email</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ user.email }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; " v-if="user.phone != ''">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Phone</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ user.phone }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Fans</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ user.fanCount }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Followers</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ user.followersCount }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Following</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ user.followingCount }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Date joined</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" >{{ user.dateD }}</p>

                                                                    </div>

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;  ">
                                                                    
                                                                        <p style="text-align: start;" class="hp-badge-test">Balance</p>

                                                                        <p style="text-align: end; font-size: 16px; font-weight: 700;" class="hp-p1-body text-black-100" > &#8358;{{ user.balanceD }}</p>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>

                                        <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyModels2">

                                            <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                                
                                            </InfiniteLoading>

                                        </div>

                                        <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column; display: none;"
                                            id="emptyModels" >
                                            <p class="hp-badge-text">No Modles...</p>
                                        </div>
                            </div>


                        </div>

                    </div>

                </div>

                <!-- FOOTER -->
                <FooterBody />

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore";
    import { db } from '@/firebase';

    export default {
        
        components: {
            SidebarBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{
                loadingText: "",
                errorText: "",
                successText: "",

                lastDocSnapshot: null,
                
                modelsList: [],
                modelCount: ""
                
            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display = 'none';
            document.getElementById("mobileTitle").textContent = 'Models';

            document.getElementById("modelsN").classList.add("active");

            document.getElementById("modelsN2").classList.add("active");

            this.getInfo();

        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            async getInfo(){

                const adminRef = doc(db, "AdminInfo", "info");
                const adminSnap = await getDoc(adminRef);

                if (adminSnap.exists()){
                    this.modelCount = adminSnap.data().modelCount;
                }

            },

            async getModels(){

                let res = [];
                const q = query(collection(db, "Users"), where("type", "==", "model"), orderBy("dateJoinedN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if(res.length > 0){

                    querySnapshot.forEach(async (doc) => {

                        let a1 = Number(doc.data().dateJoined.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().dateJoined.seconds) * 1000));

                        let result = {
                            id: doc.id,
                            userId: doc.data().userId,
                            fullName: doc.data().name,
                            userName: doc.data().displayId, 
                            profilePic: doc.data().profilePic,
                            profileBack: doc.data().profileBackground,
                            email: doc.data().email,
                            phone: doc.data().phone,

                            fanCount: doc.data().fanCount,
                            followingCount: doc.data().followingCount,
                            followersCount: doc.data().followersCount,
                            dateJoined: doc.data().dateJoined,
                            balance: doc.data().balance,
                            balanceD: Number(doc.data().balance).toLocaleString("US-us"),

                            dateD: a2.slice(0, -45),
                            dateFull: a2.slice(0, -36),
                            
                        }

                        this.modelsList.push(result);

                    })

                }

                return res.length;

            },

            async handleInfinite($state){

                const newPostCount = await this.getModels();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    if(this.modelsList.length == 0){
                        document.getElementById("emptyModels").style.display = "flex";
                        
                    }

                    //no more posts
                    document.getElementById("emptyModels2").style.display = "none";
                    return $state.complete();

            },

        }

    }
</script>